import { Payment } from '@repo-level/core-front';
import { getCurrencyName, mapCurrencySymbol } from 'helpers/currency';
import { brandSizeMap, getBrandKey } from 'modules/payments';
import React, { useMemo } from 'react';
import { ScPaymentMethodCard } from './styled';
import { ImageComponent } from 'components/Image';

interface PaymentMethodCardProps {
  method: Payment.Method;
  index: number;
  onSelect: (method: Payment.Method) => void;
  currentMethod?: Payment.Method;
}

export const PaymentMethodCard = React.memo(
  ({ method, index, onSelect, currentMethod }: PaymentMethodCardProps) => {
    const {
      iconSrc,
      termsOfService: { restrictions },
      translationKey,
      id,
    } = method;

    const { minAmountValue, amountCurrencyCode, originCryptoCurrency } =
      restrictions || {};

    const {
      width: widthSizesImages,
      height: heightSizesImages,
    } = useMemo(() => {
      const key = getBrandKey(id);
      return brandSizeMap[key];
    }, [id]);

    const currencyName = useMemo(() => {
      const symbol = mapCurrencySymbol[amountCurrencyCode].symbol;
      return getCurrencyName(symbol);
    }, [amountCurrencyCode]);

    return (
      <ScPaymentMethodCard key={`${id}_${index}`}>
        <button
          onClick={() => onSelect(method)}
          className={id === currentMethod?.id ? 'active' : ''}
        >
          {iconSrc && (
            <ImageComponent
              src={iconSrc}
              alt={`${translationKey} logo`}
              width={widthSizesImages}
              height={heightSizesImages}
            />
          )}
        </button>

        <div className="limits-wrapper">
          {minAmountValue && (
            <div className="limits">
              <span className="limits-amount">min</span>
              {originCryptoCurrency ? (
                <>
                  <span className="limits-amount">{minAmountValue}</span>
                  <span className="limits-amount">{currencyName}</span>
                </>
              ) : (
                <div>
                  <span className="limits-amount">{currencyName}</span>
                  <span className="limits-amount">{minAmountValue}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </ScPaymentMethodCard>
    );
  }
);
